/* istanbul ignore file */
import { MultiSelectInputFilter, ConditionProps } from 'framework/list';
import { MultiSelectField } from 'domain/shared/core/input';
import { useCandidateService } from 'domain/shared/candidate';
import { buildCandidateAutoSuggestLabel } from 'domain/shared/candidate';

const CandidateMultiSelectFilter = ({ label, ...props }: Omit<ConditionProps, 'children'> & { label: string }) => {
  return (
    <MultiSelectInputFilter {...props}>
      <MultiSelectField
        {...props}
        label={label}
        alias="id"
        useService={useCandidateService}
        noOptionLabel="Candidate"
        buildLabelCallback={buildCandidateAutoSuggestLabel}
      />
    </MultiSelectInputFilter>
  );
};

export default CandidateMultiSelectFilter;
